import { z } from 'zod'
import { From } from '~/enums/from'
import { TrueFalse } from '~/enums/true-false'
import { listRequestDataSchema } from './list-request-data'

/**
 * 產品子網頁 - 查詢多筆 Request Schema
 */
export const getProductPagesListRequestSchema = listRequestDataSchema.merge(
  z.object({
    /** 主類目 ID */
    pmID: z.union([z.number(), z.array(z.number())]).optional(),
    /** 子類目 ID */
    psID: z.number().optional(),
    /** 產品子網頁分類 ID */
    psiID: z.number().optional(),
    /** 更新日期 - 起 */
    modifyDateS: z.string().optional(),
    /** 更新日期 - 迄 */
    modifyDateE: z.string().optional(),
    /** 標題關鍵字 */
    q: z.string().optional(),
    /** 作者 */
    author: z.string().optional(),
    /** 是否啟用 */
    isEnable: z.array(z.nativeEnum(TrueFalse)).optional(),
    /** 從前台或後台查詢 */
    from: z.nativeEnum(From).optional(),
    /** 發佈日期 */
    releaseDate: z.date().optional()
  })
)

/**
 * 產品子網頁 - 查詢多筆 Request
 */
export interface GetProductPagesListRequest
  extends z.infer<typeof getProductPagesListRequestSchema> {}
